// import React, { useState } from "react";
// import TownPlanningSidebar from "../components/TownPlanningSidebar";
// import styles from "../styles/TownPlanningDashboard.module.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBars } from "@fortawesome/free-solid-svg-icons";
// import { FaArrowLeft, FaSearch, FaDownload, FaFilter, FaCalculator, FaFilePdf } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// export default function AboutUs() {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();
//   const handleBack = () => {
//     navigate("/")
//   };
//   return (
//     <div
//       className={styles.homeScreenContainer}
//       style={{
//         height: "100vh",
//         overflow: "hidden",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       {/* Header */}
//       <div className={styles.homeScreenHeader}>
//         {/* <button
//           onClick={() => setIsSidebarOpen(true)}
//           className={styles.homeScreenMenuBtn}
//         >
//           <FontAwesomeIcon icon={faBars} />
//         </button> */}

        
//         <button className={styles.homeScreenMenuBtn} onClick={handleBack}>
//           <FaArrowLeft />
//         </button>

//         <TownPlanningSidebar
//           isOpen={isSidebarOpen}
//           onClose={() => setIsSidebarOpen(false)}
//         />

//         <h2 style={{ color: "white" }}>About US</h2>
//       </div>

//       {/* Scrollable Content Area */}
//       <div
//         style={{
//           flex: 1,
//           overflowY: "auto",
//           padding: "20px",
//           color: "white",
//           textAlign: "center"
//         }}
//       >

//         <p style={{ fontSize: "10px", lineHeight: "1.8" }}>

//           <br /><br />

//           <strong style={{ fontSize: "18px" }}>Concept, Idea, Design</strong><br />
//           Shri. Saurabh Bapurao Navarkar (SN33)<br />
//           Town Planner<br /> <br /> <br />

//           <strong style={{ fontSize: "18px" }}>Development</strong><br />
//           Vishvaconnect Technologies LLP<br /> <br /><br />

//           <strong style={{ fontSize: "18px" }}>Contribution</strong><br />
//           Shri. Nilesh Gadge,<br />
//           Assistant Town Planner<br /><br /><br />

//           <strong style={{ fontSize: "18px" }}>Vote of Thanks</strong><br />
//           DIRECTOR OF TOWN PLANNING<br />
//           Pune

//         </p>


//       </div>
//     </div>
//   );
// }






import React from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft, 
  User, 
  Code, 
  Handshake, 
  Heart,
  Award
} from "lucide-react";

export default function AboutUs() {
  const navigate = useNavigate();
  
  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col">
      {/* --- HEADER --- */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-4">
          <button 
            onClick={handleBack} 
            className="p-2.5 hover:bg-slate-100 rounded-xl transition-all text-slate-600"
          >
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-black text-slate-900 uppercase tracking-tight">Information</h2>
        </div>
      </div>

      {/* --- CONTENT AREA --- */}
      <main className="flex-1 max-w-2xl mx-auto px-4 py-12 w-full">
        <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-400/30 ring-1 ring-slate-200 overflow-hidden text-center">
          
          {/* Top Decorative Banner */}
          <div className="p-10 bg-[#111827] text-white">
            <div className="w-16 h-16 bg-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg shadow-orange-900/40">
              <Award size={32} />
            </div>
            <h3 className="text-2xl font-black tracking-tight uppercase">About Us</h3>
            <p className="text-xs text-slate-400 font-bold tracking-[0.2em] mt-2 uppercase">PropIntel Team</p>
          </div>

          <div className="p-10 space-y-12">
            
            {/* Concept Section */}
            <div className="space-y-3">
              <div className="flex items-center justify-center gap-2 text-orange-600 mb-1">
                <User size={18} />
                <span className="text-[10px] font-black uppercase tracking-widest">Concept, Idea & Design</span>
              </div>
              <h4 className="text-xl font-black text-slate-900">Shri. Saurabh Bapurao Navarkar <span className="text-orange-600">(SN33)</span></h4>
              <p className="text-sm font-bold text-slate-500 uppercase tracking-tight">Town Planner</p>
            </div>

            {/* Development Section */}
            <div className="space-y-3 pt-8 border-t border-slate-50">
              <div className="flex items-center justify-center gap-2 text-orange-600 mb-1">
                <Code size={18} />
                <span className="text-[10px] font-black uppercase tracking-widest">Development</span>
              </div>
              <h4 className="text-xl font-black text-slate-900">Vishvaconnect Technologies LLP</h4>
            </div>

            {/* Contribution Section */}
            <div className="space-y-3 pt-8 border-t border-slate-50">
              <div className="flex items-center justify-center gap-2 text-orange-600 mb-1">
                <Handshake size={18} />
                <span className="text-[10px] font-black uppercase tracking-widest">Contribution</span>
              </div>
              <h4 className="text-xl font-black text-slate-900">Shri. Nilesh Gadge</h4>
              <p className="text-sm font-bold text-slate-500 uppercase tracking-tight">Assistant Town Planner</p>
            </div>

            {/* Vote of Thanks Section */}
            <div className="bg-slate-50 rounded-[2rem] p-8 mt-8 border border-slate-100">
              <div className="flex items-center justify-center gap-2 text-orange-600 mb-4">
                <Heart size={18} />
                <span className="text-[10px] font-black uppercase tracking-widest">Vote of Thanks</span>
              </div>
              <h4 className="text-lg font-black text-slate-900 leading-tight uppercase">Director of Town Planning</h4>
              <p className="text-sm font-bold text-slate-500 mt-1 uppercase tracking-widest">Pune</p>
            </div>

          </div>
        </div>

        <p className="text-center mt-10 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
          PropIntel • Intelligence Platform for Land Risk
        </p>
      </main>
    </div>
  );
}